import _ from 'lodash';
import {Factory, Module} from 'app/decorators';


@Module({
    name: 'app.services.models.registry',
})
@Factory('modalRegistry', function () {
    "ngInject";
    let currentOpenedModals = {};

    return {
        isOpen: function (id) {
            return _.has(currentOpenedModals, id) && currentOpenedModals[id];
        },
        push: function (id) {
            currentOpenedModals[id] = true
        },
        pop: function (id) {
            if (this.isOpen(id)) {
                delete currentOpenedModals[id];

            }
        }
    }
})
export default class F {}



// WEBPACK FOOTER //
// ./src/app/services/modals.registry.js